<template>
  <div id="results">
    <template>
      <v-card class="mx-auto">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Results</v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- <v-btn icon>
            <v-icon>mdi-magnify</v-icon>
          </v-btn>-->

          <v-btn icon>
            <v-icon>mdi-checkbox-marked-circle</v-icon>
          </v-btn>
        </v-toolbar>

        <v-list two-line>
          <v-list-item-group multiple active-class="pink--text">
            <template v-for="(item, index) in questionList">
              <v-list-item :key="`${item.id}-q`">
                <template>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                    <v-list-item-subtitle class="text--primary">Correct: {{ item.answer }}</v-list-item-subtitle>
                    <v-list-item-subtitle>Your answer: {{ item.user_answer }}</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <!-- ovdew ce biti koliko je vremena trebao da se odgovori na pitanje -->
                    <!-- <v-list-item-action-text v-text="item.action"></v-list-item-action-text> -->

                    <v-icon v-if="item.correct" color="success">mdi-shield-check</v-icon>
                    <v-icon v-else color="error">mdi-shield-alert</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-divider v-if="index + 1 < questionList.length" :key="index"></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card>
    </template>
  </div>
</template>

<script>
export default {
  computed: {
    questionList() {
      return this.$store.state.initialTestData.questionList;
    },
  },
};
</script>
